var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.23 10.392 22.467 2h7.404L17.727 13.19 29.87 29.873h-6.213l-5.619-7.764c0-.001 1.008 3.263 1.177 4.826.21 1.937-.036 3.502-.65 5.064.65-4.352-1.453-7.815-3.059-10.46-.932-1.535-1.697-2.794-1.657-3.79.133-3.355 2.531-5.696 4.298-7.12 0 0-1.108-1.074-2.835-.342-1.728.736-2.382 1.62-2.382 1.62.001 0-1.134-.068-2.33.761-.836.578-2.008 2.328-3.118 3.987-.475.71-.938 1.402-1.36 1.98-1.33 1.823-2.031 1.239-2.108 1.173.047.17.662 2.04 3.123.288 0 0 .758 1.005-.633 2.332 0 0 1.955-.101 2.047-1.972 0 0 .44.71.547 3.44.048 1.193-.199 2.942-.692 3.828l-.008.012-.007.012c-.742 1.322-2.158 2.126-3.676 2.126H2V2.001h4.977l.009 9.755 2.752-.007a5.222 5.222 0 0 0 3.493-1.356zm-2.471 4.46c-.001 0-.001-.198.391-.849.46-.76 1.296-.997 1.35-1.012h.002c-.372 1.631-1.743 1.863-1.743 1.863z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKar);
export default __webpack_public_path__ + "static/media/KAR.5feedb676e14d650467cc4d4262e3702.svg";
export { ForwardRef as ReactComponent };